import styled from 'styled-components';

import { media } from '~src/styles/media-templates';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

export const QuestionListHeader = styled.div`
  padding: 0.8em;
  background-color: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  font-size: 1.4em;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a10};
  align-items: center;
  margin-top: 2rem;
  border-radius: ${(props: { empty: boolean }) => (props.empty ? '5px' : '5px 5px 0 0')};
`;

export const ScaleContainer = styled.div`
  background-color: ${({ theme }) => theme.white.a10};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.baseBlue.a10};
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;

export const ScaleDescription = styled.span`
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const ButtonSection = styled.div`
  background-color: ${({ theme }) => theme.white.a10};
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  border-radius: 0 0 5px 5px;
  display: flex;
  justify-content: flex-end;
`;

export const CancelBtn = styled(SecondaryButton)`
  margin-right: 15px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  margin-left: 10px;
`;

export const ChangeScaleToggle = styled.span`
  flex-grow: 1;
  font-size: 15px;
  line-height: 1.73;
  text-align: right;
  color: ${({ theme }) => theme.baseBlue.a6};
  text-decoration: underline;
  cursor: pointer;
  ${media.tablet`
    text-align: left;
  `}
`;

export const ScaleName = styled.span`
  font-size: 15px;
`;
